import { getPDPUrl } from 'utils/product';
import { makeBuylistUrl } from 'utils/adtech/links';
import { type Link } from 'types/adtech';
import { type CitrusProduct } from './transform-searchresult-to-tradingcell-props';

const LINK_TEXT = 'Shop now';

function getBannerUrl(url: string, products: CitrusProduct[]) {
  if (url) return url;

  if (products.length === 1) {
    const [product] = products;
    const { id, name } = product;

    return getPDPUrl(id, name) || '';
  }

  return makeBuylistUrl(products);
}

export function generateBannerLink(citrusLink = '', products: CitrusProduct[]): Link {
  if (!products?.length) return {};

  const url = getBannerUrl(citrusLink, products);

  // Handle edge case where link hasn't been generated as expected.
  if (!url) return {};

  return {
    url,
    text: LINK_TEXT,
    altText: LINK_TEXT,
  };
}
